var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalmerchantcount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.066,
    height: 22.237,
    viewBox: "0 0 24.066 22.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-merchant-3802029",
    transform: "translate(-131.25 -77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17985",
    "data-name": "Path 17985",
    d: "M164.5,224v10.685a3.581,3.581,0,0,0,3.754,3.466h2.984a.965.965,0,0,0,.963-.963v-4.621a1.914,1.914,0,0,1,1.829-1.925h1.348a1.914,1.914,0,0,1,1.829,1.925v4.524a.965.965,0,0,0,.963.963h2.984a3.644,3.644,0,0,0,3.754-3.466V224Zm4.524,1.251h2.888a.963.963,0,1,1,0,1.925h-2.792a.95.95,0,0,1-.963-.866A.98.98,0,0,1,169.024,225.251Zm8.375,0h2.888a.963.963,0,1,1,0,1.925H177.5a.95.95,0,0,1-.963-.866A.98.98,0,0,1,177.4,225.251Z",
    transform: "translate(-31.421 -138.914)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17986",
    "data-name": "Path 17986",
    d: "M134.523,77h17.52l3.273,6.546H131.25Z",
    fill: "#6d44e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalmerchantcount);
export default __webpack_public_path__ + "static/media/totalmerchantcount.9b02b9da178e7fd56aa8d502aea907fe.svg";
export { ForwardRef as ReactComponent };